import { AxiosError, AxiosRequestConfig } from 'axios';
import { IAgentChatBody, IAgentResponse, IAgentResponseData, IAgentScorePatchBody } from '../types/agentChat.types';
import { apiGet, apiPatch, apiPost } from './api';
const { REACT_APP_API_USERS } = process.env;

/**
 * Obtiene el historial de solicitudes para un usuario específico
 * @returns El historial de solicitudes del agente
 */
export const getAgentRequestHistory = async (): Promise<IAgentResponseData[]> => {
  return apiGet<AxiosRequestConfig, IAgentResponseData[]>(`${REACT_APP_API_USERS}/agent-request-history/by-user`)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const postAgentChat = async (body: IAgentChatBody): Promise<IAgentResponse> => {
  return apiPost<AxiosRequestConfig, IAgentChatBody>(`${REACT_APP_API_USERS}/chat-soga`, body)
    .then(response => Promise.resolve(response.data))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const patchAgentChatScore = async (
  agentChatResponseId: number,
  body: IAgentScorePatchBody
): Promise<IAgentResponseData> => {
  return apiPatch<AxiosRequestConfig, IAgentScorePatchBody>(
    `${REACT_APP_API_USERS}/agent-request-history/${agentChatResponseId}/score`,
    body
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};
